import { render } from "./SecretA.vue?vue&type=template&id=feebe9dc"
import script from "./SecretA.vue?vue&type=script&lang=js"
export * from "./SecretA.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__